
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface PerformanceStageConfig {
  goalsetting_stage: boolean;
  appraisal_stage: boolean;
  banding_stage: boolean;
  disagreements_stage: boolean;
}

export const usePerformanceStage = () => {
  const [config, setConfig] = useState<PerformanceStageConfig>({
    goalsetting_stage: false,
    appraisal_stage: false,
    banding_stage: false,
    disagreements_stage: false
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPerformanceStage = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const { data, error: fetchError } = await supabase
          .from('performance_stage')
          .select('goalsetting_stage, appraisal_stage, banding_stage, disagreements_stage')
          .limit(1)
          .single();

        if (fetchError) {
          console.error('Error fetching performance stage:', fetchError);
          setError('Failed to fetch performance stage configuration');
          return;
        }

        if (data) {
          setConfig({
            goalsetting_stage: data.goalsetting_stage || false,
            appraisal_stage: data.appraisal_stage || false,
            banding_stage: data.banding_stage || false,
            disagreements_stage: data.disagreements_stage || false
          });
        }
      } catch (error) {
        console.error('Error in fetchPerformanceStage:', error);
        setError('Failed to fetch performance stage configuration');
      } finally {
        setIsLoading(false);
      }
    };

    fetchPerformanceStage();
  }, []);

  return { config, isLoading, error };
};
